module.exports = __webpack_public_path__ + "quotezone-ui/img/mortice-lock-bs-white.8ec31040.png";